import React, { Dispatch, SetStateAction, useRef } from 'react';
import { Form, Formik, FormikProps, FormikValues } from 'formik';
import s from './BankOrMobileTopUpForm.module.css';
import { Popover } from 'antd';
import MyInput from '../../../../../../components/ui/MyInput/MyInput';
import info from '../../../../../../assets/images/personalAccount/information.svg';
import MyBtn from '../../../../../../components/ui/MyBtn/MyBtn';
import * as yup from 'yup';
import { useAppSelector } from '../../../../../../hooks/redux';
import CustomDropdown from '../../../../../../components/ui/CustomDropdown/CustomDropdown';

type PropsType = {
  setCurrent: Dispatch<SetStateAction<any>>;
  setTransferData: Dispatch<SetStateAction<any>>;
  paymentMethod: string;
};

const BankOrMobileTopUpForm = (props: PropsType) => {
  const formikRef = useRef<FormikProps<FormikValues>>(null);
  const selectedAccount = useAppSelector(store => store.transactionsReducer.filters);
  const userAccountsList = useAppSelector(state => state.userReducer.accountsList.accounts);

  const getPurposeList = () => {
    const account = userAccountsList.find((acc: any) => acc.number === selectedAccount?.accountNumber);
    return account?.provider?.length ? account.provider : [];
  };

  const onSubmitAction = (values: any) => {
    const formattedValues = {
      amount: values.amount,
      provider: values?.provider?.trim() === '' ? null : values.provider,
      payment_method: Number(props.paymentMethod),
      account_number: selectedAccount?.accountNumber,
    };
    props.setCurrent('confirmation');
    props.setTransferData(formattedValues);
    if (formikRef.current) {
      formikRef.current.resetForm();
    }
  };

  const validationSchema = yup.object({
    amount: yup
      .string()
      .matches(/^[-+]?[0-9]*[.]?[0-9]+(?:[eE][-+]?[0-9]+)?$/, 'Must be only digits')
      .required('Required field')
      .max(10, 'max 10 digits')
      .test('no-leading-zero', 'invalid format', (value, context) => {
        const tempArr = context.originalValue.split('');
        const onlyZero = tempArr.every((item: string) => {
          return item === '0';
        });
        if (tempArr[0] === '0') {
          return false;
        }
        if (context.originalValue && onlyZero) {
          return false;
        } else if ((context.originalValue.match(/,/g) || []).length > 1) {
          return false;
        }
        return true;
      }),
  });
  return (
    <Formik
      innerRef={formikRef}
      initialValues={{
        amount: '',
        provider: '',
      }}
      validationSchema={validationSchema}
      onSubmit={onSubmitAction}>
      {({ values, errors, touched, handleChange, handleSubmit, setFieldValue }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <div className={s.row}>
              {/* Amount */}
              <div className={s.input_block}>
                <div className={s.input_label}>
                  * Amount
                  <Popover
                    content={'Enter the amount you want to top up your account.'}
                    color={'#EEEFEF'}
                    overlayInnerStyle={{
                      fontFamily: 'Inter',
                      width: '280px',
                      padding: '13px 16px',
                    }}>
                    <img src={info} alt="" />
                  </Popover>
                </div>
                <MyInput
                  id="amount"
                  name="amount"
                  onChange={handleChange}
                  value={values.amount}
                  isError={errors.amount}
                  touched={touched.amount}
                />
                {typeof errors.amount === 'string' && touched.amount && (
                  <div className={s.error_message}>{errors.amount}</div>
                )}
              </div>
              {getPurposeList().length > 0 && (
                <div className={s.input_block}>
                  <div className={s.input_label}>
                    Provider
                    <Popover
                      content={'Enter the provider of your transaction'}
                      color={'#EEEFEF'}
                      overlayInnerStyle={{
                        fontFamily: 'Inter',
                        width: '280px',
                        padding: '13px 16px',
                      }}>
                      <img src={info} alt="" />
                    </Popover>
                  </div>
                  <CustomDropdown
                    items={getPurposeList()}
                    id="provider"
                    name="provider"
                    placeholder={'Please select the provider'}
                    touched={touched.provider}
                  />
                  {typeof errors.provider === 'string' && touched.provider && (
                    <div className={s.error_message}>{errors.provider}</div>
                  )}
                </div>
              )}
            </div>

            <div className={s.buttonWrapper}>
              <MyBtn type={'button'} title={'Continue'} onClick={handleSubmit} />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default BankOrMobileTopUpForm;
